import API from "@/api/AdminAPI";
import store from "@/store"

class AdminController {
  constructor() {
    this.api = API
  }

  async getAdminInfo() {
    try {
      const res = await this.api.getAdminInfo();
      return res.data
    } catch (e) {
      console.error('error getAdminInfo ' + e.message);
      throw new Error('error getAdminInfo ' + e.message)
    }
  }

  /**
   * @param {1 | 2 | 3 | 4} stageId
   * */
  async setNewStage(stageId) {
    try {
      const res = await this.api.setNewStage(stageId);
      await store.dispatch('checkFilled/updateAdminInfoBlock', Number(res.data.stage))
      return res.data
    } catch (e) {
      console.error('error setNewStage ' + e.message);
      throw new Error('error setNewStage ' + e.message)
    }
  }

  applicationTypeName(el) {
    const {appealType, org} = el;
    const id = org?.id
    switch (appealType) {
      case 'MAIN_ORG':
        return 'Редактирование головной организации';
      case `FILIAL_ORG_UPDATE_${id}`:
        return 'Редактирование филиала организации';
      case 'FILIAL_ORG_CREATE':
        return 'Создание филиала';
      case `FILIAL_ORG_DELETE_${id}`:
        return 'Удаление филиала';
      default:
        return ''
    }
  }

  applicationStatusNameClass(el) {
    const {appealType, org} = el;
    const id = org?.id
    switch (appealType) {
      case 'MAIN_ORG':
        return 'UPDATE';
      case `FILIAL_ORG_UPDATE_${id}`:
        return 'UPDATE';
      case 'FILIAL_ORG_CREATE':
        return 'CREATE';
      case `FILIAL_ORG_DELETE_${id}`:
        return 'DELETE';
      default:
        return 'UPDATE'
    }
  }

  applicationStatusName(el) {
    switch (el) {
      case null:
        return 'на рассмотрении';
      case true:
        return 'Одобрена';
      case false:
        return 'Отклонена';
      default:
        return 'на рассмотрении'
    }
  }

  async getOrgsAppeals(orgType) {
    console.log(orgType);
    try {
      const res = await this.api.getOrgAppeals();
      let compareFields;
      if (orgType === "SubOrg") {
        compareFields = ['nameFull', 'name', 'nameShort', 'type', 'founderName', 'address', 'inn', 'kpp',];
      } else {
        compareFields = ['nameFull', 'name', 'nameShort', 'type', 'founderName', 'address', 'inn', 'kpp',];
      }
      return res.data.map(el => ({
        ...el,
        orgName: el.name,
        ownerName: el.owner.name,
        orgId: el.org?.id,
        applicationStatus: this.applicationStatusName(el.accept),
        applicationStatusNameClass: this.applicationStatusNameClass(el),
        applicationTypeName: this.applicationTypeName(el),
        // orgType: el.org?.id === el.owner.id,
        createDate: el.dataEntityCreateDate.slice(0, 19),
        dialogData: compareFields.map(field => {
          if (field === 'type') {
            return {
              field,
              oldValue: el.org ? el.org[field].name : null,
              value: el.orgType.name,
              changed: !el.org || el.org[field].name !== el.orgType.name
            }
          } else {
            return {
              field,
              oldValue: el.org ? el.org[field] : null,
              value: !el.org || (el[field] !== null && el[field] !== el.org[field]) ? el[field] : el.org[field],
              changed: !el.org || (el[field] !== null && el[field] !== el.org[field])
            }
          }
        })
      })).sort((a, b) => b.createDate - a.createDate);
    } catch (e) {
      console.error('error getOrgsAppeals ' + e.message)
      throw new Error('error getOrgsAppeals ' + e.message)
    }
  }

  async getFormFivesAppeals() {
    try {
      const res = await this.api.getFormsFivesAppeals();
      const apps = [];
      let filterData = res.data;
      res.data.forEach(el => {
        const searchResult = filterData.filter(a => a.jsonId === el.jsonId && a.org.id === el.org.id);
        if (apps.length === 0) {
          filterData = filterData.filter(a => !(el.jsonId === a.jsonId && a.org.id === el.org.id));
          apps.push({...el, orgId: el.org.id, data: searchResult});
        } else {
          const searchDouble = apps.find(a => a.jsonId === el.jsonId && a.org.id === el.org.id);
          if (!searchDouble) {
            filterData = filterData.filter(a => !(el.jsonId === a.jsonId && a.org.id === el.org.id));
            apps.push({...el, orgId: el.org.id, data: searchResult});
          }
        }
      })
      return apps;
    } catch (e) {
      console.error('error getFormFivesAppeals ' + e.message)
      throw new Error('error getFormFivesAppeals ' + e.message)
    }
  }
}

export default new AdminController()